import { Button } from "../types/generated";

export const buttonUrl = (button: Button<"WITHOUT_UNRESOLVABLE_LINKS">) => {
  return button.fields.url || button.fields.page?.fields.path || '';
};